import React, { useEffect } from 'react';
import ICodeBarriereGestionItem from '../../models/ICodeBarriereGestionItem';
import RenderInNewWindow from '../../utils/RenderInNewWindow';

interface IImpressionCouponBarriereProps {
  codes: ICodeBarriereGestionItem[],
  onClose: () => void,
}

const formatDate = (value: Date | string) => {
  const date = value instanceof Date ? value : new Date(value);
  return date.toLocaleDateString('fr-CA');
};

export default function ImpressionCouponBarriere({ codes, onClose }: IImpressionCouponBarriereProps) {
  useEffect(() => {
    const timer = setTimeout(() => window.print(), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <RenderInNewWindow onClose={onClose} width={400} height={600}>
      <div style={{ padding: '1rem', fontFamily: 'Arial, sans-serif' }}>
        {codes.map((code) => (
          <div
            key={code.idCodeBarriere?.toString()}
            style={{
              border: '1px dashed #333',
              marginBottom: '1.5rem',
              padding: '1rem',
              pageBreakInside: 'avoid',
            }}
          >
            <div style={{ fontWeight: 'bold', marginBottom: '0.5rem' }}>Code de barrière</div>
            <div>{code.nom} {code.prenom}</div>
            <div style={{ fontSize: '1.75rem', fontWeight: 'bold', margin: '0.75rem 0', textAlign: 'center' }}>
              {code.code}
            </div>
            <div>Du {formatDate(code.dateDebut)} au {formatDate(code.dateFin)}</div>
          </div>
        ))}
      </div>
    </RenderInNewWindow>
  );
}
